import React from "react";

import Store2 from "assets/img/storesvg/store-2.png";
import Store4 from "assets/img/storesvg/store-4.png";
import Store8 from "assets/img/storesvg/store-8.png";
import Store9 from "assets/img/storesvg/store-9.png";
import Store10 from "assets/img/storesvg/store-10.png";
import Store12 from "assets/img/storesvg/store-12.png";

import { ReactComponent as Store1 } from "assets/img/storesvg/store-1.svg";
import { ReactComponent as Store3 } from "assets/img/storesvg/store-3.svg";
import { ReactComponent as Store5 } from "assets/img/storesvg/store-5.svg";
import { ReactComponent as Store6 } from "assets/img/storesvg/store-6.svg";
import { ReactComponent as Store7 } from "assets/img/storesvg/store-7.svg";
import { ReactComponent as Store11 } from "assets/img/storesvg/store-11.svg";
import { ReactComponent as Store13 } from "assets/img/storesvg/store-13.svg";

import { ReactComponent as StoreIcon1 } from "assets/img/storesvg/storeIcon-1.svg";

import "assets/css/store.css";
const Store = () => {
  return (
    <>
      <div
        className="scroller-29cQFV auto-2K3UW5 scrollerBase-_bVAAt"
        dir="ltr"
        style={{
          overflow: "hidden scroll",
          paddingRight: 0,
          color: "hsl(210,calc(var(--saturation-factor, 1)*2.9%),86.7%)",
        }}
      >
        <div className="premiumContainer-3GGa8Q">
          <div
            className="applicationStoreHomeWrapper-1JMkgk"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "60px 40px 80px",
            }}
          >
            <div className="container-LUKdw8">
              <div
                className="content-374sTA"
                style={{
                  display: "flex",
                  maxWidth: 660,
                  flexDirection: "column",
                  rowGap: 20,
                }}
              >
                <div style={{ height: 464, maxWidth: "660px" }}>
                  <div
                    className="store-hero "
                    style={{
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: 464,
                        maxWidth: "660px",
                      }}
                    >
                      <Store1 />
                    </div>
                    <div className="wrppp">
                      <StoreIcon1 className="heroIcon" />
                      <h3
                        className="defaultColor-24IHKz heading-xl-medium-_XBxHT defaultColor-HXu-5n heroHeader-1A0uOZ"
                        data-text-variant="heading-xl/medium"
                      >
                        Discord'unu Özelleştir
                      </h3>
                      <div
                        className="text-md-normal-304U3g heroBody-20fY29"
                        data-text-variant="text-md/normal"
                        style={{ maxWidth: 312, textAlign: "center" }}
                      >
                        Emojilerini geliştir, profilini kişiselleştir ve
                        sunucularda öne çık.
                      </div>
                      <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                        <button
                          type="button"
                          className="store-buttons-subscribe"
                        >
                          <div className="contents-3ca1mk premiumSubscribeButton-17z7Tg">
                            <svg
                              className="premiumIcon-G_KEYC"
                              aria-hidden="false"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M2.98966977,9.35789159 C2.98966977,9.77582472 2.63442946,10.1240466 2.20807287,10.1240466 L1.78171628,10.1240466 C1.35535969,10.1240466 0.999948837,9.77582472 0.999948837,9.35789159 C0.999948837,8.93995846 1.35535969,8.59173658 1.78171628,8.59173658 L2.20807287,8.59173658 C2.63442946,8.59173658 2.98966977,8.93995846 2.98966977,9.35789159 Z M22.2467643,9.14892503 C24.0942527,12.9800344 22.3888264,17.5772989 18.3384388,19.3882867 C14.4302837,21.1297305 9.74036124,19.457998 7.9638186,15.6268886 C7.60857829,14.8607335 7.3954,14.0248673 7.32428372,13.189001 L5.76091938,13.189001 C5.33456279,13.189001 4.97932248,12.840612 4.97932248,12.4226788 C4.97932248,12.0047457 5.33456279,11.6565238 5.76091938,11.6565238 L8.03493488,11.6565238 C8.46129147,11.6565238 8.81653178,11.3083019 8.81653178,10.8903688 C8.81653178,10.4724357 8.46129147,10.1240466 8.03493488,10.1240466 L4.41090388,10.1240466 C3.98454729,10.1240466 3.62913643,9.77582472 3.62913643,9.35789159 C3.62913643,8.93995846 3.98454729,8.59173658 4.41090388,8.59173658 L9.45606667,8.59173658 C9.88242326,8.59173658 10.2376636,8.24334752 10.2376636,7.82541439 C10.2376636,7.40748126 9.88242326,7.05925937 9.45606667,7.05925937 L7.3954,7.05925937 C6.75586512,7.05925937 6.18727597,6.57161499 6.18727597,5.87517123 C6.18727597,5.24827153 6.68474884,4.69091591 7.3954,4.69091591 L15.4250589,4.69091591 C18.267493,4.8303384 20.9676946,6.43235968 22.2467643,9.14892503 Z M13.2662961,8.38056332 C11.0193969,9.3919615 10.0341721,11.9973566 11.065955,14.1998642 C12.097738,16.4023718 14.755645,17.3681317 17.0025442,16.3567335 C19.249614,15.3453354 20.2346682,12.7399402 19.2028853,10.5374326 C18.1711023,8.33492503 15.5131953,7.36916515 13.2662961,8.38056332 Z M16.8462589,9.84548582 L18.2673907,12.2138293 C18.338507,12.3530846 18.338507,12.4227958 18.2673907,12.5620512 L16.8462589,14.9303946 C16.7751426,15.0696499 16.6330806,15.0696499 16.5619643,15.0696499 L13.7906465,15.0696499 C13.6485845,15.0696499 13.5774682,14.9999387 13.5065225,14.9303946 L12.0852202,12.5620512 C12.0142744,12.4227958 12.0142744,12.3530846 12.0852202,12.2138293 L13.5065225,9.84548582 C13.5774682,9.7062305 13.7197008,9.7062305 13.7906465,9.7062305 L16.5619643,9.7062305 C16.7041969,9.63651925 16.7751426,9.7062305 16.8462589,9.84548582 Z"
                              ></path>
                            </svg>
                          </div>
                          <span className="buttonText-1c-l_x">Abone Ol</span>
                        </button>
                        <button type="button" className="store-buttons-gift">
                          <div>
                            <svg
                              width="24"
                              height="24"
                              className="giftIcon-25Wlbr"
                              aria-hidden="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M16.886 7.999H20C21.104 7.999 22 8.896 22 9.999V11.999H2V9.999C2 8.896 2.897 7.999 4 7.999H7.114C6.663 7.764 6.236 7.477 5.879 7.121C4.709 5.951 4.709 4.048 5.879 2.879C7.012 1.746 8.986 1.746 10.121 2.877C11.758 4.514 11.979 7.595 11.998 7.941C11.9991 7.9525 11.9966 7.96279 11.9941 7.97304C11.992 7.98151 11.99 7.98995 11.99 7.999H12.01C12.01 7.98986 12.0079 7.98134 12.0058 7.97287C12.0034 7.96282 12.0009 7.95286 12.002 7.942C12.022 7.596 12.242 4.515 13.879 2.878C15.014 1.745 16.986 1.746 18.121 2.877C19.29 4.049 19.29 5.952 18.121 7.121C17.764 7.477 17.337 7.764 16.886 7.999ZM7.293 5.707C6.903 5.316 6.903 4.682 7.293 4.292C7.481 4.103 7.732 4 8 4C8.268 4 8.519 4.103 8.707 4.292C9.297 4.882 9.641 5.94 9.825 6.822C8.945 6.639 7.879 6.293 7.293 5.707ZM14.174 6.824C14.359 5.941 14.702 4.883 15.293 4.293C15.481 4.103 15.732 4 16 4C16.268 4 16.519 4.103 16.706 4.291C17.096 4.682 17.097 5.316 16.707 5.707C16.116 6.298 15.057 6.642 14.174 6.824ZM3 13.999V19.999C3 21.102 3.897 21.999 5 21.999H11V13.999H3ZM13 13.999V21.999H19C20.104 21.999 21 21.102 21 19.999V13.999H13Z"
                              ></path>
                            </svg>
                          </div>
                          <span>Hediye Et</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 data-text-variant="heading-xl/medium">
                    İşte Nitro ile alacakların:
                  </h3>
                  <div className="store-cards-wrapper">
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Birden Fazla Profil
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Nasıl istiyorsan öyle görün; sunucularında farklı
                        avatarlar, afişler ve biyografiler kullan.
                      </div>
                      <div className="store-card-img">
                        <img className="store-card-img" src={Store2} alt="" />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Daha Fazla Arka Plan
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Kendi video arka planlarınla görüntülü aramaları
                        özelleştir.
                      </div>
                      <div className="store-card-img">
                        <Store3 />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3
                        className="defaultColor-24IHKz"
                        data-text-variant="heading-lg/medium"
                      >
                        Profiline Tarz Kat
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Hareketli avatar, profil afişi ve özel bir etiketle
                        kendini ifade et.
                      </div>
                      <div className="store-card-img">
                        <img className="store-card-img" src={Store4} alt="" />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Özel Çıkartma Erişimi
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Özel çıkartmaları her yerde kullan ve Nitro'ya özel 300
                        çıkartmaya eriş.{" "}
                        <svg
                          aria-label="Takviyeli sunucular, Sunucu Ayarları > Çıkartmalar yoluyla özel çıkartmalar yükleyebilir. Nitro kullanıcıları özel çıkartmaları her yerde kullanabilir."
                          className="itemInfoIcon-9WQ6fQ"
                          aria-hidden="false"
                          width="16"
                          height="16"
                          viewBox="0 0 12 12"
                        >
                          <path
                            fill="currentColor"
                            d="M6 1C3.243 1 1 3.244 1 6c0 2.758 2.243 5 5 5s5-2.242 5-5c0-2.756-2.243-5-5-5zm0 2.376a.625.625 0 110 1.25.625.625 0 010-1.25zM7.5 8.5h-3v-1h1V6H5V5h1a.5.5 0 01.5.5v2h1v1z"
                          ></path>
                        </svg>
                      </div>
                      <div className="store-card-img">
                        <Store5 />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Daha Fazla Emoji Gücü
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        En sevdiğin emojiyi her yerde kullan ve emojilerini
                        hareketlendir.
                      </div>
                      <div className="store-card-img">
                        <Store6 />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Sunucunu Destekle
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        2 Sunucu Takviyesi ve ilave Takviye alımlarında %30
                        indirim kazan.{" "}
                        <span role="button" tabIndex="0">
                          Daha fazla bilgi al
                        </span>
                        .
                      </div>
                      <div className="store-card-img">
                        <Store7 />
                      </div>
                    </li>
                    <li className="store-card ">
                      <h3 data-text-variant="heading-lg/medium">
                        Durumunla Hava At
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Özel profil rozetiyle Nitro Abonesi olduğunu herkese
                        göster.
                      </div>
                      <div className="store-card-img">
                        <img className="store-card-img" src={Store8} alt="" />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Daha Büyük Yüklemeler
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Arttırılmış 100 mb'lık yükleme boyutuyla istediğini
                        yükle.
                      </div>
                      <div className="store-card-img">
                        <img className="store-card-img" src={Store9} alt="" />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">HD Video</h3>
                      <div data-text-variant="text-sm/normal">
                        Tüm yayınlarını daha iyi çözünürlük seçenekleriyle
                        paylaş.{" "}
                        <svg
                          aria-label="4K'ya kadar kaynak çözünürlüğü ve 60 FPS'ye kadar ekran paylaşımı."
                          className="itemInfoIcon-9WQ6fQ"
                          aria-hidden="false"
                          width="16"
                          height="16"
                          viewBox="0 0 12 12"
                        >
                          <path
                            fill="currentColor"
                            d="M6 1C3.243 1 1 3.244 1 6c0 2.758 2.243 5 5 5s5-2.242 5-5c0-2.756-2.243-5-5-5zm0 2.376a.625.625 0 110 1.25.625.625 0 010-1.25zM7.5 8.5h-3v-1h1V6H5V5h1a.5.5 0 01.5.5v2h1v1z"
                          ></path>
                        </svg>
                        .
                      </div>
                      <div className="store-card-img">
                        <img className="store-card-img" src={Store10} alt="" />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Daha Uzun Mesajlar
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Daha yüksek karakter sınırlamasıyla aklından geçenleri
                        paylaş.
                      </div>
                      <div className="store-card-img">
                        <Store11 />
                      </div>
                    </li>
                    <li className="store-card">
                      <h3 data-text-variant="heading-lg/medium">
                        Daha Fazla Sunucu
                      </h3>
                      <div data-text-variant="text-sm/normal">
                        Katılabildiğin sunucu sayısını ikiye katlayarak 200'e
                        çıkar.
                      </div>
                      <div className="store-card-img">
                        <img className="store-card-img" src={Store12} alt="" />
                      </div>
                    </li>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p>Nitro'ya yükseltmeye hazır mısın?</p>
                  <p>
                    Sana en uygun olan planı seç ve emoji koleksiyonunu
                    oluşturmaya başla.
                  </p>
                  <div style={{ display: "flex", gap: 10 }}>
                    <button
                      type="button"
                      className="store-buttons-subscribe"
                      style={{
                        background: "hsl(139,47.1%,33.3%)",
                        color: "hsl(0,0%,100%)",
                      }}
                    >
                      <div>
                        <svg
                          className="premiumIcon-G_KEYC"
                          aria-hidden="false"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M2.98966977,9.35789159 C2.98966977,9.77582472 2.63442946,10.1240466 2.20807287,10.1240466 L1.78171628,10.1240466 C1.35535969,10.1240466 0.999948837,9.77582472 0.999948837,9.35789159 C0.999948837,8.93995846 1.35535969,8.59173658 1.78171628,8.59173658 L2.20807287,8.59173658 C2.63442946,8.59173658 2.98966977,8.93995846 2.98966977,9.35789159 Z M22.2467643,9.14892503 C24.0942527,12.9800344 22.3888264,17.5772989 18.3384388,19.3882867 C14.4302837,21.1297305 9.74036124,19.457998 7.9638186,15.6268886 C7.60857829,14.8607335 7.3954,14.0248673 7.32428372,13.189001 L5.76091938,13.189001 C5.33456279,13.189001 4.97932248,12.840612 4.97932248,12.4226788 C4.97932248,12.0047457 5.33456279,11.6565238 5.76091938,11.6565238 L8.03493488,11.6565238 C8.46129147,11.6565238 8.81653178,11.3083019 8.81653178,10.8903688 C8.81653178,10.4724357 8.46129147,10.1240466 8.03493488,10.1240466 L4.41090388,10.1240466 C3.98454729,10.1240466 3.62913643,9.77582472 3.62913643,9.35789159 C3.62913643,8.93995846 3.98454729,8.59173658 4.41090388,8.59173658 L9.45606667,8.59173658 C9.88242326,8.59173658 10.2376636,8.24334752 10.2376636,7.82541439 C10.2376636,7.40748126 9.88242326,7.05925937 9.45606667,7.05925937 L7.3954,7.05925937 C6.75586512,7.05925937 6.18727597,6.57161499 6.18727597,5.87517123 C6.18727597,5.24827153 6.68474884,4.69091591 7.3954,4.69091591 L15.4250589,4.69091591 C18.267493,4.8303384 20.9676946,6.43235968 22.2467643,9.14892503 Z M13.2662961,8.38056332 C11.0193969,9.3919615 10.0341721,11.9973566 11.065955,14.1998642 C12.097738,16.4023718 14.755645,17.3681317 17.0025442,16.3567335 C19.249614,15.3453354 20.2346682,12.7399402 19.2028853,10.5374326 C18.1711023,8.33492503 15.5131953,7.36916515 13.2662961,8.38056332 Z M16.8462589,9.84548582 L18.2673907,12.2138293 C18.338507,12.3530846 18.338507,12.4227958 18.2673907,12.5620512 L16.8462589,14.9303946 C16.7751426,15.0696499 16.6330806,15.0696499 16.5619643,15.0696499 L13.7906465,15.0696499 C13.6485845,15.0696499 13.5774682,14.9999387 13.5065225,14.9303946 L12.0852202,12.5620512 C12.0142744,12.4227958 12.0142744,12.3530846 12.0852202,12.2138293 L13.5065225,9.84548582 C13.5774682,9.7062305 13.7197008,9.7062305 13.7906465,9.7062305 L16.5619643,9.7062305 C16.7041969,9.63651925 16.7751426,9.7062305 16.8462589,9.84548582 Z"
                          ></path>
                        </svg>
                      </div>
                      <span>Abone Ol</span>
                    </button>
                    <button
                      type="button"
                      className="store-buttons-gift"
                      style={{
                        color: "hsl(0,0%,100%)",
                        background: "hsl(213,5%,42.9%)",
                      }}
                    >
                      <div>
                        <svg
                          width="24"
                          height="24"
                          className="giftIcon-25Wlbr"
                          aria-hidden="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.886 7.999H20C21.104 7.999 22 8.896 22 9.999V11.999H2V9.999C2 8.896 2.897 7.999 4 7.999H7.114C6.663 7.764 6.236 7.477 5.879 7.121C4.709 5.951 4.709 4.048 5.879 2.879C7.012 1.746 8.986 1.746 10.121 2.877C11.758 4.514 11.979 7.595 11.998 7.941C11.9991 7.9525 11.9966 7.96279 11.9941 7.97304C11.992 7.98151 11.99 7.98995 11.99 7.999H12.01C12.01 7.98986 12.0079 7.98134 12.0058 7.97287C12.0034 7.96282 12.0009 7.95286 12.002 7.942C12.022 7.596 12.242 4.515 13.879 2.878C15.014 1.745 16.986 1.746 18.121 2.877C19.29 4.049 19.29 5.952 18.121 7.121C17.764 7.477 17.337 7.764 16.886 7.999ZM7.293 5.707C6.903 5.316 6.903 4.682 7.293 4.292C7.481 4.103 7.732 4 8 4C8.268 4 8.519 4.103 8.707 4.292C9.297 4.882 9.641 5.94 9.825 6.822C8.945 6.639 7.879 6.293 7.293 5.707ZM14.174 6.824C14.359 5.941 14.702 4.883 15.293 4.293C15.481 4.103 15.732 4 16 4C16.268 4 16.519 4.103 16.706 4.291C17.096 4.682 17.097 5.316 16.707 5.707C16.116 6.298 15.057 6.642 14.174 6.824ZM3 13.999V19.999C3 21.102 3.897 21.999 5 21.999H11V13.999H3ZM13 13.999V21.999H19C20.104 21.999 21 21.102 21 19.999V13.999H13Z"
                          ></path>
                        </svg>
                      </div>
                      <span>Hediye Et</span>
                    </button>
                  </div>
                </div>
                <section
                  style={{ display: "flex" }}
                  className="store-classic-wrapper"
                >
                  <div>
                    <Store13 />
                  </div>
                  <div>
                    <svg
                      aria-hidden="false"
                      width="194"
                      height="20"
                      viewBox="0 0 194 20"
                    >
                      <title>Nitro Classic</title>
                      <g
                        fill="currentColor"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        aria-hidden="true"
                      >
                        <path d="M75.4829 6.68251L74.5173 13.1841C74.2956 14.7208 72.5637 15.4357 70.9694 15.4357C69.4817 15.4357 68.025 14.7208 68.2186 13.322L69.1842 6.68251C69.406 5.23022 71.1378 4.48437 72.7321 4.48437C74.3236 4.48437 75.7046 5.23022 75.4829 6.68251ZM73.49 0.0120925H63.1185C62.849 0.0120925 62.6273 0.203479 62.5908 0.46523L62.0856 3.90176C62.0406 4.22543 62.2849 4.5097 62.6133 4.5097H64.5051C64.696 4.5097 64.8279 4.70109 64.7493 4.8784C64.5107 5.43286 64.3423 6.03236 64.2441 6.67688L63.2785 13.3163C62.6582 17.7745 66.3745 19.9952 70.4136 19.9952C74.652 19.9952 78.8063 17.7745 79.4434 13.3248L80.409 6.68533C81.0321 2.32563 77.4449 0.104972 73.49 0.0120925ZM11.7242 8.7343L11.7775 11.9232C11.7775 11.9935 11.7326 12.047 11.6708 12.0611L10.5986 8.21924C10.5986 8.2108 10.5986 8.20517 10.5902 8.20517L7.27242 0.332948C7.18821 0.133117 7.00296 0.00927734 6.78963 0.00927734H3.02558C2.76454 0.00927734 2.55121 0.200665 2.51192 0.462416L0.00535493 18.6245C-0.0395555 18.9398 0.204645 19.224 0.519018 19.224H4.26623C4.52727 19.224 4.74902 19.0326 4.77989 18.7709L5.76231 11.5545C5.76231 11.546 5.76231 11.5404 5.76231 11.5319L5.70898 7.82802L5.81564 7.79706L6.9412 11.6389C6.9412 11.6473 6.9412 11.6473 6.94963 11.653L10.0541 18.9004C10.1383 19.0917 10.3235 19.2156 10.5284 19.2156H14.59C14.851 19.2156 15.0728 19.0242 15.1037 18.7624L17.6187 0.603142C17.6636 0.296359 17.4194 0.0120925 17.105 0.0120925H13.3802C13.1192 0.0120925 12.8974 0.203479 12.8666 0.46523L11.7242 8.71178C11.7242 8.72023 11.7242 8.72586 11.7242 8.7343ZM18.9379 19.2268H22.8788C23.1539 19.2268 23.384 19.0355 23.4233 18.7737L26.059 0.611585C26.0983 0.296359 25.8457 0.0120925 25.5145 0.0120925H21.5736C21.2985 0.0120925 21.0683 0.203479 21.029 0.46523L18.3934 18.6273C18.3541 18.9426 18.6067 19.2268 18.9379 19.2268ZM28.8715 0.456787L28.3663 3.85392C28.3214 4.16914 28.574 4.45341 28.894 4.45341H32.9499C33.2783 4.45341 33.5254 4.73768 33.4776 5.0529L31.5689 18.6273C31.5296 18.9426 31.7767 19.2268 32.1051 19.2268H36.0375C36.307 19.2268 36.5372 19.0355 36.5652 18.7737L38.5132 4.90936C38.5525 4.64761 38.7743 4.45622 39.0409 4.45622H43.4028C43.6723 4.45622 43.894 4.26484 43.9305 4.01153L44.4358 0.622844C44.4891 0.299173 44.2449 0.0149065 43.9137 0.0149065H29.3964C29.1382 0.012092 28.908 0.203479 28.8715 0.456787ZM56.2584 6.71347C56.1209 7.82802 55.2395 8.94257 53.721 8.94257H51.4446C51.1218 8.94257 50.8692 8.65831 50.9169 8.34308L51.3997 4.99943C51.4306 4.73768 51.6607 4.54629 51.9274 4.54629H54.3582C55.8121 4.54629 56.396 5.54544 56.2584 6.71347ZM54.9083 0.0120925H47.5739C47.3044 0.0120925 47.0827 0.203479 47.0462 0.46523L44.4638 18.6273C44.4189 18.9426 44.6631 19.2268 44.9915 19.2268H48.9016C49.171 19.2268 49.3928 19.0355 49.4292 18.7737L50.1871 13.3473C50.2011 13.2178 50.3162 13.1165 50.4566 13.1165H50.9618C51.0544 13.1165 51.1387 13.1615 51.1836 13.2404L54.9167 18.982C55.015 19.1368 55.1862 19.2268 55.3686 19.2268H60.1965C60.626 19.2268 60.887 18.7512 60.6344 18.3966L56.7188 12.8857C56.6261 12.7563 56.6739 12.5705 56.817 12.5001C59.3151 11.2927 60.7719 10.0628 61.2463 6.63467C61.7993 2.1258 58.9334 0.0120925 54.9083 0.0120925Z"></path>
                        <path d="M97.7021 13.8447L100.93 15.4434C101.107 15.5278 101.174 15.7417 101.09 15.919C101.082 15.9331 101.068 15.9584 101.059 15.9725C98.7379 19.0995 96.0629 19.9917 93.7163 19.9917C89.9214 19.9917 86.4268 17.771 87.0247 13.3522L87.9509 6.65645C88.5488 2.26016 92.6946 0.00854492 96.5737 0.00854492C98.8417 0.00854492 101.432 0.931708 102.592 4.02768C102.684 4.27255 102.561 4.55118 102.317 4.64969L98.968 5.94156C98.7379 6.02599 98.4852 5.94156 98.3561 5.73328C97.8284 4.89456 96.8236 4.5343 95.8103 4.5343C94.4152 4.56526 93.0286 5.33362 92.8349 6.648L91.9087 13.3409C91.7178 14.6018 92.9192 15.4012 94.2861 15.4012C95.2966 15.4012 96.4165 14.979 97.107 13.9855C97.2362 13.8081 97.4944 13.7378 97.7021 13.8447Z"></path>
                        <path d="M188.225 13.8447L191.453 15.4434C191.63 15.5278 191.697 15.7417 191.613 15.919C191.604 15.9331 191.59 15.9584 191.582 15.9725C189.261 19.0995 186.586 19.9917 184.239 19.9917C180.444 19.9917 176.95 17.771 177.547 13.3522L178.474 6.65645C179.072 2.26016 183.22 0.00854492 187.097 0.00854492C189.367 0.00854492 191.958 0.931708 193.115 4.02768C193.207 4.27255 193.084 4.55118 192.839 4.64969L189.488 5.94156C189.258 6.02599 189.005 5.94156 188.876 5.73328C188.346 4.89456 187.344 4.5343 186.33 4.5343C184.935 4.56526 183.549 5.33362 183.355 6.648L182.429 13.3409C182.238 14.6018 183.439 15.4012 184.803 15.4012C185.817 15.4012 186.934 14.979 187.624 13.9855C187.759 13.8081 188.02 13.7378 188.225 13.8447Z"></path>
                        <path d="M102.724 18.6885L105.177 1.07236C105.239 0.627666 105.621 0.287109 106.075 0.287109H109.157C109.654 0.287109 110.061 0.695214 110.061 1.19338C110.061 1.23842 110.061 1.27782 110.053 1.31722L108.298 13.8221C108.228 14.3203 108.573 14.7763 109.073 14.8523C109.112 14.8607 109.157 14.8607 109.197 14.8607H114.984C115.481 14.8607 115.888 15.2688 115.888 15.767C115.888 15.8064 115.888 15.8514 115.88 15.8908L115.467 18.9333C115.405 19.3865 115.024 19.7186 114.569 19.7186H103.622C103.122 19.7186 102.718 19.3105 102.718 18.8123C102.715 18.7729 102.715 18.725 102.724 18.6885Z"></path>
                        <path d="M135 18.6181L131.191 1.002C131.099 0.588262 130.731 0.287109 130.31 0.287109H127.152C126.807 0.287109 126.493 0.48694 126.341 0.793723L117.78 18.4098C117.718 18.5337 117.687 18.6716 117.687 18.8095C117.687 19.3105 118.094 19.7158 118.591 19.7158H121.794C122.153 19.7158 122.476 19.499 122.622 19.1782L123.863 16.3665C124.009 16.0372 124.331 15.8289 124.691 15.8289H128.508C128.946 15.8289 129.322 16.1357 129.398 16.5663L129.858 18.9868C129.942 19.4174 130.313 19.7242 130.748 19.7242H134.122C134.184 19.7242 134.254 19.7158 134.313 19.7017C134.796 19.5947 135.107 19.1106 135 18.6181ZM125.816 11.4551L127.947 5.77543H128.138L128.713 11.4551H125.816Z"></path>
                        <path d="M136.988 15.9809L139.157 14.1739C139.534 13.8587 140.078 13.8728 140.446 14.2049C141.341 15.0183 142.624 15.4348 143.794 15.4348C145.105 15.4348 146.256 14.9648 146.447 13.9516C146.663 12.7442 144.976 12.2235 143.421 11.9983C140.392 11.5058 137.656 9.06277 138.341 5.38137C139.076 1.39882 142.571 0 146.121 0C148.235 0 150.222 0.537574 151.817 2.43738C152.083 2.76105 152.047 3.24514 151.724 3.52097C151.71 3.53504 151.685 3.55193 151.671 3.566L149.363 5.17309C149.041 5.39544 148.611 5.38137 148.305 5.14213C147.508 4.51168 146.472 4.2049 145.552 4.18238C144.325 4.15142 143.284 4.62145 143.177 5.61216C143.039 6.73515 144.019 7.23332 145.498 7.56544C148.855 8.19589 152.137 9.48776 151.233 14.3203C150.52 18.1086 147.247 20 143.07 20C140.985 20 138.456 19.0459 136.892 17.1573C136.589 16.7971 136.634 16.2736 136.988 15.9809Z"></path>
                        <path d="M153.419 15.9809L155.589 14.1739C155.965 13.8587 156.518 13.8728 156.877 14.2049C157.776 15.0183 159.053 15.4348 160.226 15.4348C161.537 15.4348 162.685 14.9648 162.879 13.9516C163.095 12.7442 161.408 12.2235 159.85 11.9983C156.824 11.5058 154.087 9.06277 154.769 5.38137C155.505 1.39882 158.999 0 162.55 0C164.664 0 166.651 0.537574 168.245 2.43738C168.512 2.76105 168.475 3.24514 168.153 3.52097C168.139 3.53504 168.113 3.55193 168.099 3.566L165.792 5.17309C165.469 5.39544 165.04 5.38137 164.734 5.14213C163.937 4.51168 162.904 4.2049 161.983 4.18238C160.757 4.15142 159.715 4.62145 159.608 5.61216C159.471 6.73515 160.451 7.23332 161.93 7.56544C165.287 8.19589 168.568 9.48776 167.664 14.3203C166.951 18.1086 163.678 20 159.502 20C157.419 20 154.887 19.0459 153.324 17.1573C153.021 16.7971 153.066 16.2736 153.419 15.9809Z"></path>
                        <path d="M176.537 1.31722L174.084 18.9333C174.022 19.378 173.64 19.7186 173.186 19.7186H170.129C169.629 19.7186 169.225 19.3105 169.225 18.8123C169.225 18.7729 169.225 18.7279 169.234 18.6885L171.687 1.07236C171.748 0.627666 172.13 0.287109 172.585 0.287109H175.642C176.138 0.287109 176.548 0.695214 176.548 1.19338C176.545 1.23279 176.545 1.27782 176.537 1.31722Z"></path>
                      </g>
                    </svg>
                    <p>
                      İşleri basit mi tutmak istersin? Daha az avantajın yer
                      aldığı hafif bir planın keyfini çıkar, Discord'a destek
                      olmaya devam et ve Sunucu Takviyelerinde %30 indirim
                      kazan. <strong>Aylık ₺13,49</strong> veya{" "}
                      <strong>yıllık ₺134,49</strong> ödeme planı arasında seçim
                      yap.
                    </p>
                    <div className="store-perk-list-item-wrapper">
                      <div className="store-perk-list-item">
                        <svg
                          aria-hidden="false"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM10 8C10 6.8952 9.1032 6 8 6C6.8944 6 6 6.8952 6 8C6 9.1056 6.8944 10 8 10C9.1032 10 10 9.1056 10 8ZM9 14L6 18H18L15 11L11 16L9 14Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <div data-text-variant="text-sm/normal">
                          Özel etiket, hareketli avatar ve özel Nitro rozetiyle
                          profiline tarz kat
                        </div>
                      </div>
                      <div className="store-perk-list-item">
                        <svg
                          aria-hidden="false"
                          width="24"
                          height="24"
                          viewBox="0 0 8 12"
                        >
                          <path
                            d="M4 0L0 4V8L4 12L8 8V4L4 0ZM7 7.59L4 10.59L1 7.59V4.41L4 1.41L7 4.41V7.59Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M2 4.83V7.17L4 9.17L6 7.17V4.83L4 2.83L2 4.83Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <div data-text-variant="text-sm/normal">
                          Sunucu Takviyelerinde %30 indirim
                        </div>
                      </div>
                      <div className="store-perk-list-item">
                        <svg
                          aria-hidden="false"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M16.4770909,19 C18.0152727,16.936 18.9381818,14.531 19.1323636,12 L21.7527273,12 C21.3829091,15.056 19.3363636,17.65 16.4770909,19 Z M2.24618182,12 L4.86654545,12 C5.06072727,14.531 5.98363636,16.936 7.52181818,19 C4.66254545,17.65 2.616,15.056 2.24618182,12 Z M7.52181818,3 C5.98254545,5.064 5.06072727,7.469 4.86654545,10 L2.24618182,10 C2.616,6.944 4.66254545,4.35 7.52181818,3 Z M13.0909091,10 L13.0909091,2.369 C15.3294545,4.416 16.6930909,7.111 16.9505455,10 L13.0909091,10 Z M13.0909091,19.631 L13.0909091,12 L16.9505455,12 C16.6930909,14.889 15.3294545,17.584 13.0909091,19.631 Z M10.9090909,12 L10.9090909,19.631 C8.66945455,17.584 7.30581818,14.889 7.04836364,12 L10.9090909,12 Z M10.9090909,10 L7.04836364,10 C7.30581818,7.111 8.66945455,4.416 10.9090909,2.369 L10.9090909,10 Z M19.1323636,10 C18.9381818,7.469 18.0163636,5.064 16.4770909,3 C19.3363636,4.35 21.3829091,6.944 21.7527273,10 L19.1323636,10 Z M0,11 C0,17.075 5.37163636,22 12,22 C18.6272727,22 24,17.075 24,11 C24,4.925 18.6272727,0 12,0 C5.37163636,0 0,4.925 0,11 Z"
                            transform="translate(0 1)"
                          ></path>
                        </svg>
                        <div data-text-variant="text-sm/normal">
                          Özel ve hareketli emojileri her yerde kullan
                        </div>
                      </div>
                      <div className="store-perk-list-item">
                        <svg
                          aria-hidden="false"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.2137 2.00088L2.27111 13.3826C1.9299 13.8168 2.00535 14.4455 2.43963 14.7867C2.61581 14.9251 2.83338 15.0004 3.05744 15.0004H7V21.0004C7 21.5527 7.44772 22.0004 8 22.0004H16C16.5523 22.0004 17 21.5527 17 21.0004V15.0004H20.9425C21.4948 15.0004 21.9425 14.5527 21.9425 14.0004C21.9425 13.7763 21.8673 13.5588 21.7289 13.3826L12.7863 2.00088C12.4451 1.56661 11.8165 1.49116 11.3822 1.83237C11.3195 1.88162 11.2629 1.93819 11.2137 2.00088Z"
                          ></path>
                        </svg>
                        <div data-text-variant="text-sm/normal">
                          8MB yerine 50MB arttırılmış yükleme hızı
                        </div>
                      </div>
                      <div className="store-perk-list-item">
                        <svg
                          aria-hidden="false"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M19 1C19.552 1 20 1.447 20 2V3L23 2V6L20 5V6C20 6.553 19.552 7 19 7H15C14.448 7 14 6.553 14 6V2C14 1.447 14.448 1 15 1H19Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M20 13.5V9H22V15.5C22 16.604 21.103 17.5 20 17.5H13V19.5H17V21.5H7V19.5H11V17.5H4C2.897 17.5 2 16.604 2 15.5V4.5C2 3.397 2.897 2.5 4 2.5H12V4.5H4V13.5H20Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <div data-text-variant="text-sm/normal">
                          1080p ve 60 FPS'ye kadar ekran paylaşımı
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                      <button
                        type="button"
                        className="store-buttons-subscribe"
                        style={{
                          background: "hsl(213,5%,42.9%)",
                          color: "hsl(0,0%,100%)",
                        }}
                      >
                        <div className="contents-3ca1mk premiumSubscribeButton-17z7Tg">
                          <svg
                            className="premiumIcon-G_KEYC"
                            aria-hidden="false"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M2.98966977,9.35789159 C2.98966977,9.77582472 2.63442946,10.1240466 2.20807287,10.1240466 L1.78171628,10.1240466 C1.35535969,10.1240466 0.999948837,9.77582472 0.999948837,9.35789159 C0.999948837,8.93995846 1.35535969,8.59173658 1.78171628,8.59173658 L2.20807287,8.59173658 C2.63442946,8.59173658 2.98966977,8.93995846 2.98966977,9.35789159 Z M22.2467643,9.14892503 C24.0942527,12.9800344 22.3888264,17.5772989 18.3384388,19.3882867 C14.4302837,21.1297305 9.74036124,19.457998 7.9638186,15.6268886 C7.60857829,14.8607335 7.3954,14.0248673 7.32428372,13.189001 L5.76091938,13.189001 C5.33456279,13.189001 4.97932248,12.840612 4.97932248,12.4226788 C4.97932248,12.0047457 5.33456279,11.6565238 5.76091938,11.6565238 L8.03493488,11.6565238 C8.46129147,11.6565238 8.81653178,11.3083019 8.81653178,10.8903688 C8.81653178,10.4724357 8.46129147,10.1240466 8.03493488,10.1240466 L4.41090388,10.1240466 C3.98454729,10.1240466 3.62913643,9.77582472 3.62913643,9.35789159 C3.62913643,8.93995846 3.98454729,8.59173658 4.41090388,8.59173658 L9.45606667,8.59173658 C9.88242326,8.59173658 10.2376636,8.24334752 10.2376636,7.82541439 C10.2376636,7.40748126 9.88242326,7.05925937 9.45606667,7.05925937 L7.3954,7.05925937 C6.75586512,7.05925937 6.18727597,6.57161499 6.18727597,5.87517123 C6.18727597,5.24827153 6.68474884,4.69091591 7.3954,4.69091591 L15.4250589,4.69091591 C18.267493,4.8303384 20.9676946,6.43235968 22.2467643,9.14892503 Z M13.2662961,8.38056332 C11.0193969,9.3919615 10.0341721,11.9973566 11.065955,14.1998642 C12.097738,16.4023718 14.755645,17.3681317 17.0025442,16.3567335 C19.249614,15.3453354 20.2346682,12.7399402 19.2028853,10.5374326 C18.1711023,8.33492503 15.5131953,7.36916515 13.2662961,8.38056332 Z M16.8462589,9.84548582 L18.2673907,12.2138293 C18.338507,12.3530846 18.338507,12.4227958 18.2673907,12.5620512 L16.8462589,14.9303946 C16.7751426,15.0696499 16.6330806,15.0696499 16.5619643,15.0696499 L13.7906465,15.0696499 C13.6485845,15.0696499 13.5774682,14.9999387 13.5065225,14.9303946 L12.0852202,12.5620512 C12.0142744,12.4227958 12.0142744,12.3530846 12.0852202,12.2138293 L13.5065225,9.84548582 C13.5774682,9.7062305 13.7197008,9.7062305 13.7906465,9.7062305 L16.5619643,9.7062305 C16.7041969,9.63651925 16.7751426,9.7062305 16.8462589,9.84548582 Z"
                            ></path>
                          </svg>
                        </div>
                        <span className="buttonText-1c-l_x">Abone Ol</span>
                      </button>
                      <button
                        type="button"
                        className="store-buttons-gift"
                        style={{
                          background: "hsl(213,5%,42.9%)",
                          color: "hsl(0,0%,100%)",
                        }}
                      >
                        <div>
                          <svg
                            width="24"
                            height="24"
                            className="giftIcon-25Wlbr"
                            aria-hidden="false"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16.886 7.999H20C21.104 7.999 22 8.896 22 9.999V11.999H2V9.999C2 8.896 2.897 7.999 4 7.999H7.114C6.663 7.764 6.236 7.477 5.879 7.121C4.709 5.951 4.709 4.048 5.879 2.879C7.012 1.746 8.986 1.746 10.121 2.877C11.758 4.514 11.979 7.595 11.998 7.941C11.9991 7.9525 11.9966 7.96279 11.9941 7.97304C11.992 7.98151 11.99 7.98995 11.99 7.999H12.01C12.01 7.98986 12.0079 7.98134 12.0058 7.97287C12.0034 7.96282 12.0009 7.95286 12.002 7.942C12.022 7.596 12.242 4.515 13.879 2.878C15.014 1.745 16.986 1.746 18.121 2.877C19.29 4.049 19.29 5.952 18.121 7.121C17.764 7.477 17.337 7.764 16.886 7.999ZM7.293 5.707C6.903 5.316 6.903 4.682 7.293 4.292C7.481 4.103 7.732 4 8 4C8.268 4 8.519 4.103 8.707 4.292C9.297 4.882 9.641 5.94 9.825 6.822C8.945 6.639 7.879 6.293 7.293 5.707ZM14.174 6.824C14.359 5.941 14.702 4.883 15.293 4.293C15.481 4.103 15.732 4 16 4C16.268 4 16.519 4.103 16.706 4.291C17.096 4.682 17.097 5.316 16.707 5.707C16.116 6.298 15.057 6.642 14.174 6.824ZM3 13.999V19.999C3 21.102 3.897 21.999 5 21.999H11V13.999H3ZM13 13.999V21.999H19C20.104 21.999 21 21.102 21 19.999V13.999H13Z"
                            ></path>
                          </svg>
                          <span>Hediye Et</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div
          aria-hidden="true"
          style={{
            position: "absolute",
            pointeEvents: "none",
            minHeight: 0,
            minWidth: 1,
            flex: "0 0 auto",
            height: 0,
          }}
        ></div>
      </div>
    </>
  );
};

export default Store;
